import { useState, useEffect } from 'react';

const CurrentDate = () => {
  const [date, setDate] = useState('');

  useEffect(() => {
    const updateDate = () => {
      const now = new Date();

      // Format the date: Monday, Dec 16, 2024
      const formattedDate = now.toLocaleDateString('en-US', {
        weekday: 'long', // Full day name (Monday)
        month: 'short', // Short month name (Dec)
        day: '2-digit', // Two-digit day (16)
        year: 'numeric', // Full year (2024)
      });

      setDate(`${formattedDate}`);
    };

    updateDate(); // Call once immediately
    const interval = setInterval(updateDate, 1000); // Update every second

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return <div>{date}</div>;
};

export default CurrentDate;
